<template>
  <div class="container">
    <!-- 总内容 -->
    <!-- applyType="2" -->
    <Apply
        v-if="homeShowType == 0"
        :applyType="applyType"
        :loadProduct="loadProduct"
        @handleLoanBtn="handleLoanBtn"
    ></Apply>
    <!-- <Order
      :order="order"
      v-if="homeShowType == 1"
      @handleRepaymentBtn="handleRepaymentBtn"
    ></Order> -->
    <Dialogs
        v-model="isShow"
        :confirm-button-text="l.home_confirm_btn"
        :cancel-button-text="l.home_cancel_btn"
        :show-cancel-button="true"
        confirm-button-color="#ee0a24"
        @confirm="confirmLoan"
        :overlay="true"
    >
      <div class="blocks" @click.stop v-if="LoanInfo">
        <!-- 借款额度 -->
        <div class="first">
          <div class="title">{{ l.o_loan_loan_amounts }}</div>
          <div class="desc">${{ formatMoney(LoanInfo.loanAmount) }}</div>
        </div>
        <!-- 到账金额---还款金额 -->
        <div class="second">
          <div class="item bf">
            <div class="title">{{ l.o_loan_to_the_account_amounts }}(NT$)</div>
            <div class="desc">{{ formatMoney(LoanInfo.receiveAmount) }}</div>
          </div>
          <div class="item">
            <div class="title">{{ l.o_item_repay_money }}(NT$)</div>
            <div class="desc">{{ formatMoney(LoanInfo.dueAmount) }}</div>
          </div>
        </div>
        <!-- 详情 -->
        <div class="third">
          <div class="box">
            <div class="title">{{ l.o_loan_loan_time_init_day }}</div>
            <div class="desc">{{ LoanInfo.loanCycle }}</div>
          </div>
          <div class="box">
            <div class="title">{{ l.o_loan_schedule_the_repayment_date }}</div>
            <div class="desc">{{ LoanInfo.dueTime }}</div>
          </div>
          <div class="box">
            <div class="title">{{ l.other_bank }}</div>
            <div class="desc">{{ LoanInfo.bankName }}</div>
          </div>
          <div class="box">
            <div class="title">{{ l.other_name }}</div>
            <div class="desc">{{ LoanInfo.realName }}</div>
          </div>
          <div class="box">
            <div class="title">{{ l.o_loan_bank_account_or_cardnum }}</div>
            <div class="desc">{{ LoanInfo.bankAccount }}</div>
          </div>
        </div>
      </div>
      <div class="diaMsg">{{ l.home_dialog_msg }}</div>
    </Dialogs>

    <!-- LINE弹框 -->
    <div v-if="showLinePopup" class="line-popup-overlay" @click="closeLinePopup">
      <div class="line-popup" @click.stop>
        <!-- 关闭按钮 -->
        <div class="line-popup-close" @click="closeLinePopup">
          <div class="close-icon">×</div>
        </div>

        <!-- 标题 -->
        <div class="line-popup-title">
          <span class="title-emoji">🎉</span>
          <span class="title-text">{{ l.line_popup_title }}</span>
        </div>
        
        <!-- 内容 -->
        <div class="line-popup-content" v-html="l.line_popup_content">
        </div>
        
        <!-- 按钮 -->
        <div class="line-popup-button" @click="joinLine">
          <div class="button-icon">
            <div class="envelope-icon">
              <Icon name="envelop-o"/>
            </div>
          </div>
          <span class="button-text">{{ l.line_popup_button }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatMoney} from "@/utils";
import {Toast, Dialog, Icon} from "vant";
import {getEquipment} from "@/utils/index";
import {
  queryloanstatus,
  saasLoanapp,
  userStatus,
  // getAuthStatus,
  // vayHub,
  queryproductsSaas,
  loanApply,
} from "@/services/home";
import {queryUserLoanStatus, loanappqueryList} from "@/services/order";

import {device, position, appConfig} from "@/services/user";
import {dateFormat} from "@/utils";
import l from "@/locales";

import Apply from "./components/apply";
// import Order from "./components/order";
import UAParser from "ua-parser-js";

export default {
  name: "index",
  components: {
    Apply,
    // Order,
    Dialogs: Dialog.Component,
    Icon,
  },
  data() {
    return {
      homeShowType: 0,
      applyType: 1,
      checked: true,
      popupShow: false,
      loan: 0,
      serviceFee: 0, // 服务费
      isShow: false,
      LoanInfo: null,
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      isNewUser: false,
      order: undefined,
      vuyType: -1,

      isNewLoan: false,
      loadProduct: {},
      showLinePopup: false, // 控制LINE弹框显示
      config: {},
    };
  },
  computed: {
    applyTime() {
      return dateFormat("YYYY-mm-dd", new Date());
    },
  },
  methods: {
    formatMoney,
    confirmLoan() {
      // 设备类型
      let system = "";
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        system = "ios";
      } else if (/(Android)/i.test(navigator.userAgent)) {
        system = "android";
      } else {
        // alert("这是PC");
        system = "other";
      }
      console.log("confirmLoan");
      const params = {
        loanAmount: parseInt(this.LoanInfo.loanAmount),
        channel: "baidu",
        system,
      };
      saasLoanapp(params).then((res1) => {
        if (res1.code == 200) {
          // if (this.isNewUser) {
          //   //新用户(首借)
          //   // 首页埋点
          //   this.homeBuriedPoint(localStorage.getItem("channel"));
          // }

          Toast.success(this.l.home_toast_success);
          setTimeout(() => {
            this.$router.push("/order");
          }, 1000);
        }
      });
    },
    async getProductList(selectAmount) {
      let _this = this;
      if (this.isNewLoan) {
        let userLoanStatus = await queryUserLoanStatus();
        if (userLoanStatus.result.isApply) {
          this.$router.push({
            path: "/confirmLoan",
            query: {
              mchId: this.loadProduct.mchId,
              selectAmount,
              // application_id: this.order.application_id,
            },
          });
        } else {
          _this.goToOrder();
        }
        // confirmLoan
      } else {
        console.log("老客");

        if (process.env.VUE_APP_GENRE === "nested") {
          window.applySubmit = this.applySubmit;
          this.$tools.androidMethod(
              "borrowAnother",
              {
                // timestamp: this.order.apply_time.toString(),
              },
              "applySubmit"
          );
        } else {
          this.applySubmit();
        }
      }
    },

    applySubmit() {
      let _this = this;
      loanApply()
          .then((res) => {
            console.log(res);
            if (res.result.data == 0) {
              Toast.fail(this.l.home_toast_no_new_order);
            } else {
              Toast.success(
                  this.l.home_toast_order_view.replace("$1", res.result.data)
              );
            }
            setTimeout(() => {
              _this.goToOrder();
            }, 2000);
          })
          .catch((err) => {
            console.log(err);
            setTimeout(() => {
              _this.goToOrder();
            }, 2000);
          });
    },
    async goToOrder() {
      let queryList = await loanappqueryList({orderType: 2});
      this.$router.push({
        path: "/order",
        query: {
          orderType: queryList.result.length ? 2 : 1,
        },
      });
    },
    async handleLoanBtn(val) {
      if (!this.checked) {
        Toast.fail(this.l.home_toast_fail);
        return;
      }
      if (this.vuyType == 2) {
        console.log("handleLoanBtn", this.vuyType);
        // if (sessionStorage.getItem("pathUrl")) {
        //   window.location.href = sessionStorage.getItem("pathUrl");
        if (this.$store.state.user.userInfo.vayHubAuthUrl) {
          let h5AuthURL = this.$store.state.user.userInfo.vayHubAuthUrl;
          // let h5AuthURL = "http://H5.vn.v1c.cc:4999/mall/Vayhub205?cell=0772623794";
          // Toast(h5AuthURL)
          let pathUrl = this.VIC_URL(
              h5AuthURL,
              localStorage.getItem("channel")
          );
          sessionStorage.setItem("pathUrl", pathUrl);
          localStorage.setItem("vic_mall", "true");
          setTimeout(() => {
            window.location.href = pathUrl;
          }, 100);
        } else {
          this.$router.push("/other");
        }
        return;
      }
      let selectAmount;
      if (val) {
        selectAmount = val;
      }
      if (this.$store.state.user.userInfo && this.$store.state.user.userInfo.phone) {
        let mobile;
        mobile = this.$store.state.user.userInfo.phone
            .toString()
            .startsWith("0")
            ? this.$store.state.user.userInfo.phone
            : "0" + this.$store.state.user.userInfo.phone;
        // console.log("this.isNewLoan", this.isNewLoan);
        userStatus({mobile}).then((res) => {
          // console.log("this.isNewLoan333", res);
          if (res.result.loan_status == "1") {
            if (res.result.ocr_status == "0") {
              this.$router.push("/idcard");
            } else if (res.result.person_status == "0") {
              this.$router.push("/basicInformation");
            } else if (res.result.comp_status == "0") {
              this.$router.push("/work");
            } else if (
                res.result.contact_status == "0" ||
                res.result.card_status == "0"
            ) {
              this.$router.push("/other");
            } else {
              // console.log("this.isNewLoan",this.isNewLoan);
              // if (this.isNewLoan) {
              //   // console.log("this.isNewLoan22",this.isNewLoan,mobile);
              //   getAuthStatus({ mobile }).then((res) => {
              //     if (res.result.vayHubAuth == 1) {
              //       this.getProductList(selectAmount);
              //     } else {
              //       let h5AuthURL = this.$store.state.user.userInfo
              //         .vayHubAuthUrl;
              //       let pathUrl = this.VIC_URL(
              //         h5AuthURL,
              //         localStorage.getItem("channel")
              //       );
              //       sessionStorage.setItem("pathUrl", pathUrl);
              //       localStorage.setItem("vic_mall", "true");
              //       setTimeout(() => {
              //         window.location.href = pathUrl;
              //       }, 100);
              //     }
              //   });
              // } else {
              this.getProductList(selectAmount);
              // }
            }
          } else {
            this.getProductList(selectAmount);
          }
        });
      } else {
        this.$router.push("/login");
      }
    },
    VIC_URL(h5AuthURL) {
      let callBack = `${location.protocol}//${window.location.host}/home?vayHub=1`;
      // console.log(callBack,encodeURIComponent(callBack));
      // return `${h5AuthURL}&callBack=${callBack}`;
      return `${h5AuthURL}&callBack=${callBack}`;
    },
    handleRepaymentBtn() {
      this.$router.push("/pay");
    },
    checkVayHub() {
      if (localStorage.getItem("vic_mall") && localStorage.getItem("vayHub")) {
        // if (document.referrer) {
        //   let mobile = this.$store.state.user.userInfo.phone
        //       .toString()
        //       .startsWith("0")
        //       ? this.$store.state.user.userInfo.phone
        //       : "0" + this.$store.state.user.userInfo.phone;
        //   this.$saveAppsFlyer("运营商认证完成");
        //   vayHub({mobile});
        this.handleLoanBtn();
        this.vuyType = 1;
        // }
        localStorage.removeItem("vic_mall");
        localStorage.removeItem("vayHub");
      }
    },
    // 关闭LINE弹框
    closeLinePopup() {
      this.showLinePopup = false;
      // 设置标记，表示用户已经看过这个弹框
      localStorage.setItem('hasSeenLinePopup', 'true');
    },
    // 跳转到LINE
    joinLine() {
      // 这里可以添加跳转到LINE的逻辑
      // 例如：window.open('line://ti/p/@yourlineid', '_blank');
      // 或者跳转到LINE的网页版
      window.open(this.config.line, '_blank');
      this.showLinePopup = false;
      // 设置标记，表示用户已经看过这个弹框
      localStorage.setItem('hasSeenLinePopup', 'true');
    },
    async init() {
      this.order = undefined;

      queryproductsSaas().then((res) => {
        this.isNewLoan = res.result.isNewLoan;
        localStorage.setItem("isNewLoan", this.isNewLoan ? "1" : "2");
        this.loadProduct = res.result.productList[0];

        if (this.$store.state.user.userInfo && this.$store.state.user.userInfo.phone) {
          this.$saveAppsFlyer("进入首页");
          // this.checkVayHub();

          // 如果是新用户且未看过LINE弹框，显示LINE弹框
          if (this.isNewLoan && !localStorage.getItem('hasSeenLinePopup')) {
            setTimeout(() => {
              this.showLinePopup = true;
            }, 500); // 延迟500ms显示弹框
          }
        }
      });
      queryloanstatus().then((res) => {
        console.log("queryloanstatus", res);
        this.order = res.result;
        // if (
        //   this.order &&
        //   this.order.application_id &&
        //   this.order.loan_status != 9 &&
        //   this.order.loan_status != 1 &&
        //   this.order.bid_status != 7
        // ) {
        //   this.homeShowType = 1;
        // } else {
        //   this.homeShowType = 0;
        // }
        // this.homeShowType = 1;
      });
    },
  },
  activated() {
    // this.$router.push("/confirmLoan");
    // 激活当前页调用
    if (this.$store.state.user.userInfo && this.$store.state.user.userInfo.phone) {
      this.init();
      this.applyType = 2;

      const parser = new UAParser();
      const result = parser.setUA(navigator.userAgent).getResult();

      let model = result.device.model;
      let os = result.os.name;
      let val = result.device.vendor;
      let version = result.os.version;
      console.log("UAParser", result);
      console.log("model,os,val,version", model, os, val, version);

      // const mobileDetect = require("@/utils/mobileDetect");
      // console.log("mobileDetect", mobileDetect.default);
      // let {model, os, val, version} = mobileDetect.default;

      // model" SM-G955U "
      // os"AndroidOS"
      // val""
      // version8

      let visitorId = localStorage.getItem("visitorId");
      let deviceData = getEquipment();
      deviceData.w = Math.round(deviceData.w);
      deviceData.h = Math.round(deviceData.h);

      var regex = /(iPhone\d+,\d+)/;
      var match = regex.exec(window.navigator.userAgent);
      var deviceIphone = match ? match[1] : "";
      model = deviceIphone ? deviceIphone : model;

      console.log("device", deviceData, visitorId);
      let mobile = this.$store.state.user.userInfo.phone
          .toString()
          .startsWith("0")
          ? this.$store.state.user.userInfo.phone
          : "0" + this.$store.state.user.userInfo.phone;
      let coords = JSON.parse(localStorage.getItem("coords") || "{}");
      const pams = {
        uuid: visitorId,
        imei: visitorId,
        account_id: mobile,
        record: [
          {
            ...deviceData,
            lon: coords.longitude,
            lat: coords.latitude,
            screenResolution: deviceData.screenResolution,
            system: os,
            version: version,
            deviceId: visitorId,
            resolution: deviceData.w + "x" + deviceData.h,
            phoneModel: model,
            mobile_model: model,
            brands: val,
            applist: [
              {
                firstTime: "2018-12-17 12:59:00",
                lastTime: "2018-12-17 12:59:00",
                name: "com.android.cts.priv.ctsshim",
                packageName: "com.android.cts.priv.ctsshim",
                systemApp: "1",
                versionCode: "7.0-2996264",
              },
            ],
          },
        ],
      };
      device(pams);
      if (coords && coords.latitude && coords.longitude) {
        position({
          record: [{position_x: coords.latitude, position_y: coords.longitude}],
        });
      }
    } else {
      this.applyType = 1;
    }
  },
  mounted() {
    // this.$saveAppsFlyer(`申请贷款`,null,123456789);
    // this.$router.push("/idcard");

  },
  created() {
    if (this.$route.query.channel) {
      // console.log("this.$route.query.channel", this.$route.query.channel);
      localStorage.setItem("channel", this.$route.query.channel);
    }
    if (this.$route.query.vayHub) {
      localStorage.setItem("vayHub", this.$route.query.vayHub);
    }

    // if (
    //   this.$route.query.channel == "414a" ||
    //   localStorage.getItem("channel") == "414a"
    // ) {
    //   this.$router.push("/404")
    // }

    // 获取全局配置（包含 line、phone 等）
    appConfig().then(res => {
      const arr = JSON.parse(res.result?.about?.additionalContactInfo || "[]");
      const result = arr.reduce((acc, item) => {
        acc[item.name] = item.value;
        return acc;
      }, {});
      this.config = result;
    });
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  height: 100%;
  background: #F5F5F5;

}

.my-swipe {
  min-height: 150px;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  padding: 0 15px;
  box-sizing: border-box;

  .swp_item_box {
    width: 100%;
    height: 100%;
    // background-color: #39a9ed;
    border-radius: @br-5;
    overflow: hidden;

    img {
      width: 100%;
    }
  }
}

.title {
  color: #3a3a3a;
  text-align: justify;
  margin-bottom: 10px;
}

.allContent {
  position: relative;
  width: 100%;

  .mainContent {
    padding: 0 30px;
  }
}

.popup_body {
  width: 80vw;
  max-height: 80vh;
  padding: 15px;
  box-sizing: border-box;
}

.diaMsg {
  width: 100%;
  margin: 10px 0;
  text-align: center;
}

.blocks {
  position: relative;
  margin: 0 5px;
  width: 100%;
  // height: 460px;
  background: #ffffff;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 20px;
  // .login_header {
  //     position: absolute;
  //     width: 60px;
  //     height: 60px;
  //     line-height: 60px;
  //     padding: 0 15px;
  //     font-size: 20px;
  // }
  .first {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #747576;
    }

    .desc {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-top: 6px;
    }
  }

  .second {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;

    .item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex: 1;

      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        background: #ffffff;
        border-radius: 20px;
        font-size: 12px;
        color: #747576;
      }

      .desc {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin-top: 10px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #000000;
      }
    }

    .bf::before {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      content: "";
      width: 1px;
      height: 33px;
      background-color: #e3e3e3;
    }
  }

  .third {
    width: 78vw;
    margin: 0 auto;

    .box {
      display: flex;
      align-items: center;
      padding-top: 15px;
      margin-top: 5px;
      border-top: 1px solid #f3f4f5;

      .title {
        flex: 1;
        margin-left: 10px;
        margin-right: 15px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #212223;
      }

      .desc {
        flex: 1;
        margin-left: 15px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858585;
      }
    }
  }

  .receive {
    margin: 0 auto;
    margin-top: 22px;
    width: 294px;
    height: 40px;
    background: #fb8d5f;
    border-radius: 18px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .instructions {
    width: 250px;
    margin: 0 auto;
    margin-top: 10px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #858585;
  }
}

// LINE弹框样式
.line-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.line-popup {
  position: relative;
  width: 320px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 24px 20px 20px;
  margin: 0 20px;
}

.line-popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.close-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #666;
  font-weight: bold;
}

.line-popup-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 8px;
}

.title-emoji {
  font-size: 20px;
  margin-right: 8px;
}

.title-text {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
}

.line-popup-content {
  text-align: center;
  font-size: 13px;
  color: #000000;
  line-height: 1.5;
  margin-bottom: 24px;
}

.line-popup-button {
  width: 100%;
  height: 48px;
  background: #00C851;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;
}

.line-popup-button:hover {
  background: #00B048;
}

.line-popup-button:active {
  background: #009E3F;
}

.button-icon {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.envelope-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #ffffff;
  margin-right: 4px;
}

.line-logo {
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
}

.button-text {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}
</style>
